import Enquiry from ".";

export const enquiryUserRoutes = (data) => {
  const user_role_in_org = data?.selectedOrganization?.verificationData?.role; //promoter||"admin"||"staff"
  if (user_role_in_org === "promoter") {
    return [];
  }
  return [
    {
      path: "/:lang/user/enquiry",
      title: "enquiry",
      layout: "user",
      routeType: "organization",
      component: Enquiry,
    },
  ];
};
